import NaveBarPaginas from "../Layout/NaveBarPaginas";
import styles from "./EquipeP.module.css";

import foto1 from "../../Imgs/fotos/1.png";
import foto2 from "../../Imgs/fotos/2.png";
import foto3 from "../../Imgs/fotos/3.png";
import foto4 from "../../Imgs/fotos/4.png";
import foto5 from "../../Imgs/fotos/5.png";
import foto6 from "../../Imgs/fotos/6.png";
import foto7 from "../../Imgs/fotos/7.png";
import foto8 from "../../Imgs/fotos/8.png";
import foto9 from "../../Imgs/fotos/9.png";
import foto10 from "../../Imgs/fotos/10.png";

import {
  GiBatMask,
  GiBattleAxe,
  GiBatwingEmblem,
  GiBulletBill,
} from "react-icons/gi";
function EquipeP() {
  return (
    <div className={styles.container}>
      <NaveBarPaginas></NaveBarPaginas>

      <div className={styles.conteudo}>
        {/*Gabriela*/}
        <div className={styles.caixa}>
          <div className={styles.foto}>
            <img src={foto1} alt="gabriela"></img>
          </div>
          <div className={styles.texto}>
            <h2>Ficha</h2>

            <h3>Jogadora</h3>
            <p>Gabriela Dambrós</p>
            <p>Professora de Geografia</p>

            <h3>Habilidade Especial</h3>
            <p>Usar jogos no trabalho</p>

            <h3>Função</h3>
            <p>Coordenadora do projeto</p>
            <div className={styles.icons}>
              <GiBatMask />
              <GiBattleAxe />
              <GiBatwingEmblem />
              <GiBulletBill />
            </div>
          </div>
        </div>
      </div>

      <div className={styles.conteudo}>
        {/*Dominique*/}
        <div className={styles.caixa}>
          <div className={styles.foto}>
            <img src={foto2} alt="Dominique"></img>
          </div>
          <div className={styles.texto}>
            <h2>Ficha</h2>

            <h3>Jogadora</h3>
            <p>Dominique Brzoskowski</p>
            <p>Graduanda em Geografia</p>

            <h3>Habilidade Especial</h3>
            <p>Maratonar séries e filmes de longa duração</p>

            <h3>Função</h3>
            <p>Equipe de conteúdo do grupo Geografia em Jogos</p>
            <div className={styles.icons}>
              <GiBatMask />
              <GiBattleAxe />
              <GiBatwingEmblem />
              <GiBulletBill />
            </div>
          </div>
        </div>
      </div>

      <div className={styles.conteudo}>
        {/*Fagner*/}
        <div className={styles.caixa}>
          <div className={styles.foto}>
            <img src={foto3} alt="Fagner"></img>
          </div>
          <div className={styles.texto}>
            <h2>Ficha</h2>

            <h3>Jogador</h3>
            <p>Fagner Duarte</p>
            <p>Graduando em Geografia</p>

            <h3>Habilidade Especial</h3>
            <p>Assistir animes.</p>
            <p>
              "Não importa o quão poderoso você se torne nunca tente fazer tudo
              sozinho, caso contrario irá falhar". Uchiha Itachi
            </p>

            <h3>Função</h3>
            <p>Equipe de conteúdo do grupo Geografia em Jogos</p>
            <div className={styles.icons}>
              <GiBatMask />
              <GiBattleAxe />
              <GiBatwingEmblem />
              <GiBulletBill />
            </div>
          </div>
        </div>
      </div>

      <div className={styles.conteudo}>
        {/*Guilherme*/}
        <div className={styles.caixa}>
          <div className={styles.foto}>
            <img src={foto4} alt="Guilherme"></img>
          </div>
          <div className={styles.texto}>
            <h2>Ficha</h2>

            <h3>Jogador</h3>
            <p>Guilherme Crizel</p>
            <p>Mestrando em Geografia</p>

            <h3>Habilidade Especial</h3>
            <p>Jogar varias jogos e ser ruim em todos eles.</p>

            <h3>Função</h3>
            <p>Equipe criativa do grupo Geografia em Jogos</p>
            <div className={styles.icons}>
              <GiBatMask />
              <GiBattleAxe />
              <GiBatwingEmblem />
              <GiBulletBill />
            </div>
          </div>
        </div>
      </div>

      <div className={styles.conteudo}>
        {/*Natacha*/}
        <div className={styles.caixa}>
          <div className={styles.foto}>
            <img src={foto10} alt="Natacha"></img>
          </div>
          <div className={styles.texto}>
            <h2>Ficha</h2>

            <h3>Jogadora</h3>
            <p>Natacha Alves</p>
            <p>Graduanda em Geografia</p>

            <h3>Habilidade Especial</h3>
            <p>Ler livros e utilizar jogos como metodologia de ensino.</p>

            <h3>Função</h3>
            <p>Equipe de conteúdo do grupo Geografia em Jogos</p>
            <div className={styles.icons}>
              <GiBatMask />
              <GiBattleAxe />
              <GiBatwingEmblem />
              <GiBulletBill />
            </div>
          </div>
        </div>
      </div>

      <div className={styles.conteudo}>
        {/*Nathaniel*/}
        <div className={styles.caixa}>
          <div className={styles.foto}>
            <img src={foto5} alt="Nathaniel"></img>
          </div>
          <div className={styles.texto}>
            <h2>Ficha</h2>

            <h3>Jogador</h3>
            <p>Nathaniel Farias</p>
            <p>Graduando em Geografia</p>

            <h3>Habilidade Especial</h3>
            <p>Transformar Café em Código</p>
            <p>
              <font color="green">print("Hello, World!")</font>
            </p>

            <h3>Função</h3>
            <p>Equipe criativa do grupo Geografia em Jogos</p>
            <div className={styles.icons}>
              <GiBatMask />
              <GiBattleAxe />
              <GiBatwingEmblem />
              <GiBulletBill />
            </div>
          </div>
        </div>
      </div>

      <div className={styles.conteudo}>
        {/*Pedro*/}
        <div className={styles.caixa}>
          <div className={styles.foto}>
            <img src={foto6} alt="Pedro"></img>
          </div>
          <div className={styles.texto}>
            <h2>Ficha</h2>

            <h3>Jogador</h3>
            <p>Pedro Simões</p>
            <p>Graduando em Geografia</p>

            <h3>Habilidade Especial</h3>
            <p>Gostar de jogos, porém jogar pouco eles.</p>

            <h3>Função</h3>
            <p>Equipe de conteúdo do grupo Geografia em Jogos</p>
            <div className={styles.icons}>
              <GiBatMask />
              <GiBattleAxe />
              <GiBatwingEmblem />
              <GiBulletBill />
            </div>
          </div>
        </div>
      </div>

      <div className={styles.conteudo}>
        {/*Rodrigo*/}
        <div className={styles.caixa}>
          <div className={styles.foto}>
            <img src={foto7} alt="Rodrigo"></img>
          </div>
          <div className={styles.texto}>
            <h2>Ficha</h2>

            <h3>Jogador</h3>
            <p>Rodrigo Peraldo</p>
            <p>Graduando em Geografia</p>

            <h3>Habilidade Especial</h3>
            <p>"Só sei jogar PES e GTA"</p>

            <h3>Função</h3>
            <p>Equipe de conteúdo do grupo Geografia em Jogos</p>
            <div className={styles.icons}>
              <GiBatMask />
              <GiBattleAxe />
              <GiBatwingEmblem />
              <GiBulletBill />
            </div>
          </div>
        </div>
      </div>

      <div className={styles.conteudo}>
        {/*Thales*/}
        <div className={styles.caixa}>
          <div className={styles.foto}>
            <img src={foto8} alt="Thales"></img>
          </div>
          <div className={styles.texto}>
            <h2>Ficha</h2>

            <h3>Jogador</h3>
            <p>Thales Rodrigues</p>
            <p>Mestrando em Geografia</p>

            <h3>Habilidade Especial</h3>
            <p>
              Descobrir na internet muitos artigos legais sobre geografia e
              videogames, mas atrasar por 10 meses a entrega do seu próprio
              artigo.
            </p>

            <h3>Função</h3>
            <p>Equipe de conteúdo do grupo Geografia em Jogos</p>
            <div className={styles.icons}>
              <GiBatMask />
              <GiBattleAxe />
              <GiBatwingEmblem />
              <GiBulletBill />
            </div>
          </div>
        </div>
      </div>

      <div className={styles.conteudo}>
        {/*vinicius*/}
        <div className={styles.caixa}>
          <div className={styles.foto}>
            <img src={foto9} alt="Vinicius"></img>
          </div>
          <div className={styles.texto}>
            <h2>Ficha</h2>

            <h3>Jogador</h3>
            <p>Vinicius Gomes</p>
            <p>Graduando em Geografia</p>

            <h3>Habilidade Especial</h3>
            <p>
              Ter todo o mapa do jogo na cabeça antes mesmo de passar da
              primeira missão.
            </p>

            <h3>Função</h3>
            <p>Equipe de conteúdo do grupo Geografia em Jogos</p>
            <div className={styles.icons}>
              <GiBatMask />
              <GiBattleAxe />
              <GiBatwingEmblem />
              <GiBulletBill />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
export default EquipeP;
